export interface IApiErrorMessage {
  title: string
  subtitle?: string
}

/**
 * The backend returns a single `message` string that, for actionable validation
 * errors, packs two sentences separated by ". " — the reason first, the
 * actionable detail (e.g. a max amount) second. Mirrors how
 * phi-fondosmutuos-web-inversionista splits the same backend message: the
 * second sentence becomes the bold title, the first becomes the subtitle.
 */
export const splitApiErrorMessage = (message?: string): IApiErrorMessage => {
  if (!message) return { title: 'Ocurrió un error. Intente nuevamente.' }

  const parts = message.split('. ').filter(Boolean)
  if (parts.length !== 2) return { title: message }

  const [subtitle, title] = parts
  return { title, subtitle }
}
